var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"py-2 px-3 rounded",class:{toggled:_vm.isToggled}},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }